<template>
	<div class="transitor-container" v-bind:class="{ active: transitorShown }">

		<div class="transitor__base">{{transitorScore}}</div>
	<!--
	media/rws_prorail/transitors/RWS-ProRail_transitor_middel.json
	media/rws_circulair/transitors/RWS_transitor_middel.json

	-->
		<Lottie
			:animationpath="baseUrl + transitorAnimation"
			:audiopath="baseUrl + transitorSoundFX"
		    :name="id"
		    class="transitor__animation"
		    loop="false"
		    autoplay="false"
			ratio="meet"
		    ref="animation"
		/>
	</div>
</template>

<script>
	import bodyMoving from 'bodymovin';
	import { url} from '../const/base';
	import {mapGetters , mapActions} from 'vuex';
	import Lottie from './Lottie.vue';

	export default {

		props:[],

		components:{
			Lottie,
		},

		created(){
		},

		mounted(){

			console.log(this.transitorSoundFX);

		},

		data(){
			return {
				id: 'animcontainer',
				baseUrl : url,
			}
		},
		methods:{
			...mapActions([
				"loadAnimation",
				"loadAudio"
			]),

		},
		computed:{
			...mapGetters([
				"transitorScore",
				"transitorShown",
				"transitorAnim",
				"transitorSound",
			]),

			transitorAnimation(){

				console.log(this.transitorAnim);

				if(this.transitorAnim){
					return this.transitorAnim;
				}else{
					return 'media/rws_circulair/transitors/RWS_transitor_middel.json';
				}

			},

			transitorSoundFX(){

				console.log(this.transitorSound);

				if(this.transitorSound){
					return this.transitorSound;
				}else{
					return 'media/instance_2/Nordwin_transitor.mp3';
				}

			},

		},
		watch:{
			transitorScore : function(){
				this.$refs.animation.play();
			},
		},

	}
</script>



// WEBPACK FOOTER //
// src/components/Transitors.vue